import AbsComponent from "./AbsComponent";
import Pagination from "./Pagination";

export default class RecentViewChar extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', _l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);

        this.page = new Pagination('.layer.recent-list > .ui-pagination ul', 8, this.render.bind(this));

        const watch = this.watch(this.store.getState, 'recentChar', this.isEqual);
        this.store.subscribe( watch( this.addList.bind(this) ) );

        this.recentlyList = JSON.parse(localStorage.getItem('gameInfoRecentlyViewList')) || [];
        this.render();
        this.addEvents();
    }

    render(_page = 1){
        let template = this.recentlyList.map( (it, idx) =>{ 
            if (idx<(_page-1)*8) return '';
            if (idx>((_page-1)*8)+7) return '';

            let lang = $('html').attr('lang') || 'ko';
            const item = $(`
                <div class="character-list-items">
                    <div class="profileimg">
                        ${(lang==='ko')?`
                        <img src="${this.store.getState().config.profileImgPath}/game_profile_images/bns/images?gameServerKey=${it.server_id}&charKey=${it.character_id}">
                        `:`
                        <img src="${this.store.getState().config.staticPath}/img/profile/${it.clazz}.png">
                        `}
                    </div>
                    <div class="result-items-info">
                        <div class="name">${it.character_name}</strong></div>
                        <span class="server">${it.server_name}</span>
                        <span class="races">${it.job_name}</span>
                        <span class="level">Lv. ${it.level}${it.mastery_level>0?` · ${this.l10n.masteryLevel.replace('{n}', it.mastery_level)}`:``}</span>
                    </div>
                </div>
            `);

            item.on('click', e=>{
                this.router.goMultiParam({ c: it.character_name, compare: 'false' });
            })

            return item;
        } );

        $('.layer.recent-list .character-list').empty().append(template);

        this.page.render({
            page: _page,
            total: this.recentlyList.length
        });
    }

    addList(_char){
        for (let i=0; i < this.recentlyList.length; i++) {
            if ( this.recentlyList[i].character_id === _char.character_id ) {
                // this.recentlyList.splice(i, 1);
                return false;
            }
        }
        if (!_char.character_id) {
            return false;
        }
        this.recentlyList.unshift( _char );
        
        this.recentlyList = this.recentlyList.slice(0,100);
        localStorage.setItem('gameInfoRecentlyViewList', JSON.stringify(this.recentlyList));

        this.render();
    }

    addEvents(){
        $('.btn-recent-character.pos-bottom').on('click', (e)=>{
            $('.layer.recent-list').addClass('is-active');
        });

        $('.layer.recent-list .btn-recent-character').on('click', (e)=>{
            $('.layer.recent-list').removeClass('is-active');
        });
    }

} // end of class